module.exports = __webpack_public_path__ + "static/media/she_is_Vulnerable_sign.f87ea653.png";